import { useState } from "react"
import type { FC } from "react"
import type { Post } from "../../models/posts"
import postsApi from "../../../../services/postsApi"

interface EditPostFormProps {
  post: Post
  onClose: () => void
  onSaved: () => void
}

const EditPostForm: FC<EditPostFormProps> = ({ post, onClose, onSaved }) => {
  const [content, setContent] = useState(post.content_pure ?? "")
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    if (!content.trim()) return
    setSaving(true)
    try {
      await postsApi.updatePost(post.id, content)
      onSaved()
      onClose()
    } catch {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-lg w-full p-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-medium">Editar Post</h3>
          <button className="text-gray-400 hover:text-gray-600" onClick={onClose}>
            <i className="fa fa-times" />
          </button>
        </div>
        <textarea
          className="w-full border border-gray-200 rounded p-2 text-sm min-h-[150px] resize-none focus:outline-none focus:border-blue-300"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <div className="flex justify-end gap-2 mt-4">
          <button className="px-4 py-1.5 text-sm text-gray-600 hover:text-gray-800" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-1.5 rounded text-sm hover:bg-blue-600 disabled:opacity-50"
            onClick={handleSave}
            disabled={saving || content.trim().length === 0}
          >
            {saving ? <i className="fa fa-spinner fa-spin" /> : "Guardar"}
          </button>
        </div>
      </div>
    </div>
  )
}

export default EditPostForm